import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Film, Download, Loader2, AlertCircle } from 'lucide-react';
import axios from 'axios';
import ProjectLogoHeader from '../components/ProjectLogoHeader';

const API_URL = '/api';

const SharedVideoPage = () => {
  const { shareToken } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const res = await axios.get(`${API_URL}/shared-video/${shareToken}`);
        setVideo(res.data);
      } catch {
        setError('Video nao encontrado ou link expirado');
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, [shareToken]);

  const streamUrl = `${API_URL}/shared-video/${shareToken}/stream`;

  if (loading) return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <Loader2 size={32} className="text-gold animate-spin" />
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center gap-4 p-4">
      <AlertCircle size={48} className="text-red-400" />
      <p className="text-white text-lg">{error}</p>
      <p className="text-gray-500 text-sm">Verifique o link e tente novamente</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-950 flex flex-col" data-testid="shared-video-page">
      <ProjectLogoHeader
        projectId={video?.project_id}
        projectName={video?.project_name}
        projectLogoUrl={video?.project_logo_url}
        subtitle={(
          <span className="flex items-center gap-1.5">
            <Film size={11} className="text-gold" />
            <span className="font-medium">{video?.filename}</span>
            <span className="text-gray-400">· {video?.uploaded_by}</span>
          </span>
        )}
        rightSlot={(
          <a href={streamUrl} download
            className="flex items-center gap-1.5 px-3 py-1.5 bg-gold/10 hover:bg-gold/20 border border-gold/30 rounded text-gold text-xs transition-colors"
            data-testid="download-shared-video">
            <Download size={12} /> Download
          </a>
        )}
        dark
      />
      <div className="flex-1 flex items-center justify-center p-4">
        <video
          src={streamUrl}
          className="max-w-full max-h-[85vh] rounded-lg shadow-2xl"
          controls
          autoPlay
          data-testid="shared-video-player"
        />
      </div>
    </div>
  );
};

export default SharedVideoPage;
